<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
        Ошибка получения данных
      </h4>
      <div class="alert-body">
        Не удалось найти обьект с данным id. Проверьте
        <b-link
          class="alert-link"
          :to="{ name: 'railway_structure-sector-list'}"
        >
          Список обьектов
        </b-link>
        список обьектов.
      </div>
    </b-alert>

    <template v-if="data">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <sector-info-card :sector-data="data" @open-tab="goTab" />

        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-responsability-info-card :data="data.user"/>
        </b-col>
        <b-col>
          <b-tabs v-model="activeTab">
            <b-tab title="Замеры" lazy>
              <measurements-list :object-active-option="data.number"></measurements-list>
            </b-tab>
            <b-tab title="Станции" lazy>
              <stations-list :extra-filters="{sector: data.id}"></stations-list>
            </b-tab>
            <b-tab title="Платформы" lazy>
              <platforms-list :extra-filters="{sector: data.id}"></platforms-list>
            </b-tab>
            <b-tab title="Мостовые переходы" lazy>
              <bridges-list :extra-filters="{sector: data.id}"></bridges-list>
            </b-tab>
            <b-tab title="Навесы" lazy>
              <sheds-list :extra-filters="{sector: data.id}"></sheds-list>
            </b-tab>
            <b-tab title="Торцевые ограждения" lazy>
              <fencings-list :extra-filters="{sector: data.id}"></fencings-list>
            </b-tab>
            <b-tab title="Опоры" lazy>
              <pillars-list :extra-filters="{sector: data.id}"></pillars-list>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
  import store from '@/store'
  import router from '@/router'
  import {ref, onBeforeMount, onBeforeUnmount, onMounted} from '@vue/composition-api'
  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../sectorStoreModule'

  import {
    BCard, BCardBody, BCardTitle, BCardSubTitle, BTable, BRow, BCol, BAlert, BLink, BTabs, BTab
  } from 'bootstrap-vue'

  import useSector from '../useSector'

  import SectorInfoCard from '../components/SectorInfoCard.vue'
  import UserResponsabilityInfoCard from '@/views/apps/user/components/UserResponsabilityInfoCard.vue'

// Lists

// Sector structure List
  import StationsList from '@/views/apps/railway_structure/station/views/List.vue'
  import PlatformsList from '@/views/apps/railway_structure/platform/views/List.vue'
  import BridgesList from '@/views/apps/railway_structure/bridge/views/List.vue'
  import ShedsList from '@/views/apps/railway_structure/shed/views/List.vue'
  import FencingsList from '@/views/apps/railway_structure/fencing/views/List.vue'
  import PillarsList from '@/views/apps/railway_structure/pillar/views/List.vue'

  import MeasurementsList from '@/views/apps/measurement/measurement/views/List.vue'


export default {
  components: {

    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BRow,
    BCol,
    BAlert,
    BLink,
    BTabs,
    BTab,

    // Local Components
    SectorInfoCard,
    UserResponsabilityInfoCard,
    StationsList,
    PlatformsList,
    BridgesList,
    ShedsList,
    FencingsList,
    PillarsList,
      MeasurementsList


  },

  setup() {

      const data = ref(null)

      // Счётчики в карточке кликабельны: открывают вкладку со связанными объектами,
      // чтобы из любой сущности можно было перейти к её составу и обратно.
      const activeTab = ref(0)
      const tabKeys = ['measurement', 'station', 'platform', 'bridge', 'shed', 'fencing', 'pillar']
      const goTab = key => {
        const index = tabKeys.indexOf(key)
        if (index >= 0) activeTab.value = index
      }

      const { fetchDataUrl } = useSector()

      // Re-register module with additional options
      onBeforeMount(() => {

        if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })

        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      onMounted( async ()=>{
        await store.dispatch(fetchDataUrl, { id: router.currentRoute.params.id })
                .then(response => { data.value = response.data })
                .catch((err) => {})
      })

      return {
        data,
        activeTab,
        goTab,
      }
    },
}
</script>
